import React from 'react';

export default function NoDataGraphOverlay() {
  return (
    <div className="nodataoverlay">
      <h4>Não Existem amostras suficientes do período para gerar um gráfico</h4>
    </div>
  );
}
